export default __webpack_public_path__ + "static/media/Gallery4.fd15ff13.webp";